<ng-template #treeTemplate let-nodes>
  <ul class="compo-tree">
    <li *ngFor="let item of nodes">
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: item }"/>

      <ng-container *ngIf="item.children && item.children.length > 0 && item.expanded">
        <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: item.children }"/>
      </ng-container>
    </li>
  </ul>
</ng-template>

<ng-container *ngIf="treeData">
  <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: treeData }"/>
</ng-container>
